import React, { useEffect, useState } from "react";
import { Loader2, Save, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";

function Amount({ id, label, hint, value, onChange }) {
  return (
    <div>
      <Label htmlFor={id} className="text-xs mb-1.5 block">{label}</Label>
      <div className="flex items-center gap-2">
        <span className="text-sm text-[#575A57]">CHF</span>
        <Input id={id} type="number" min="0" step="1" value={value} onChange={(e) => onChange(e.target.value)} className="w-28" data-testid={`${id}-input`} />
      </div>
      <p className="text-[11px] text-[#575A57] mt-1">{hint}</p>
    </div>
  );
}

export function TelegramRules({ linked }) {
  const [rules, setRules] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => { api.get("/admin/telegram-alert/rules").then(({ data }) => setRules(data)); }, []);
  if (!rules) return null;
  const set = (k) => (v) => setRules((r) => ({ ...r, [k]: v }));

  const save = async () => {
    setBusy("save");
    try {
      const { data } = await api.put("/admin/telegram-alert/rules", {
        gap_event_chf: Number(rules.gap_event_chf || 0), gap_week_chf: Number(rules.gap_week_chf || 0), evening_recap: rules.evening_recap,
      });
      setRules(data);
      toast.success("Réglages enregistrés");
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); } finally { setBusy(""); }
  };
  const recapNow = async () => {
    setBusy("recap");
    try { await api.post("/admin/telegram-alert/recap-now"); toast.success("Récap envoyé, regardez votre téléphone"); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); } finally { setBusy(""); }
  };

  return (
    <div className="bg-white border border-[#E5E5E0] rounded-xl p-5 space-y-5" data-testid="telegram-rules">
      <h2 className="font-heading text-base font-medium">Écarts de réassort suspects</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Amount id="gap-event" label="Un seul réassort dépasse" hint="Barquettes manquantes à un réassort, au coût de revient." value={rules.gap_event_chf} onChange={set("gap_event_chf")} />
        <Amount id="gap-week" label="Cumul 7 jours d'un distributeur dépasse" hint="Un message au plus par distributeur et par semaine." value={rules.gap_week_chf} onChange={set("gap_week_chf")} />
      </div>
      <div className="flex items-center justify-between border-t border-[#EEEEE8] pt-4">
        <div>
          <h2 className="font-heading text-base font-medium">Récap du soir à 22h00</h2>
          <p className="text-xs text-[#575A57]">Commandes web du jour et ventes par machine.</p>
        </div>
        <Switch checked={!!rules.evening_recap} onCheckedChange={set("evening_recap")} data-testid="evening-recap-switch" />
      </div>
      <div className="flex flex-wrap gap-2">
        <Button onClick={save} disabled={!!busy} className="bg-[#1F4E3D] hover:bg-[#173B2E] text-white" data-testid="telegram-rules-save">
          {busy === "save" ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}Enregistrer
        </Button>
        <Button variant="outline" onClick={recapNow} disabled={!linked || !!busy} data-testid="telegram-recap-now">
          {busy === "recap" ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />}Envoyer le récap maintenant
        </Button>
      </div>
    </div>
  );
}
